<template>
    <div class="monitoring-container">
        <div style="height: 100px; width: 134px; display: flex; align-items: center; justify-content: center;">
            <div style="overflow: hidden; position: absolute; height: 100px; width: 134px; display: flex; align-items: center; justify-content: center; border-radius: 10px; box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);">
                <TwilioWebcam :recording-width="320" :width="134" :height="100" style="z-index: 1; position: absolute;"
                              :record-local="false"
                              :disconnect-on-reconnecting="false"
                              :auto-record="true"
                              :show-network-quality="false"
                              :transcribe="false"
                              :analyze-security="true"
                              ref="webcam"
                              @video-track="videoTrackReceived($event)"
                              @responsevideo="responseVideoReceived($event)"
                              @inactive="inactive()"
                ></TwilioWebcam>
            </div>
            <transition name="monitoring-slide-x" v-if="shouldVerifyFace">
                <v-card single-line :tile="false" color="warning" class="monitoring-card pa-1"
                        v-if="state === 'not_found'">
                    <b>{{$t('general.where_are_you')}}</b>
                </v-card>
            </transition>
            <transition name="monitoring-slide-x" v-if="shouldVerifyFace">
                <v-card single-line :tile="false" color="error" class="monitoring-card pa-1"
                        v-if="state === 'multiple'">
                    <b>{{$t('general.not_alone')}}</b>
                </v-card>
            </transition>
        </div>
    </div>
</template>

<script>
    import TwilioWebcam from "./TwilioWebcam";
    import videoFaceDetection from "./mixins/videoFaceDetection";

    export default {
        name: "Monitoring",
        components: {TwilioWebcam},
        mixins: [videoFaceDetection],

        data: () => ({
            state: null
        }),
        mounted() {

        },
        computed: {
            currentmeasure() {
                return this.$store.state.assessment.assessmentmeasure;
            },
            shouldVerifyFace(){
                return this.$store.state.assessment.assessment.project.should_verify_face;
            },
        },
        methods: {
            personNotFound() {
                this.state = 'not_found';
            },
            multipleFound() {
                this.state = 'multiple';
            },
            stateNormal() {
                this.state = null;
            },
            responseVideoReceived(responsevideo) {
                if (!this.currentmeasure) return;
                this.$http.post('/assessmentmeasures/' + this.currentmeasure.assessmentmeasureid + '/monitoring', {responsevideoid: responsevideo.responsevideoid}).then(() => {

                });
            },
            inactive() {

            },
            startMonitoring() {
                this.$refs.webcam.start();
            },
            stopMonitoring() {
                this.$refs.webcam.stop();
            }
        }
    }
</script>

<style scoped>
    .monitoring-container {
        position: fixed;
        top: 2px;
        left: 50%;
        margin-left: -67px;
    }

    .monitoring-card {
        min-width: 150px !important;
        position: absolute;
        text-align: center;
        transform: translateX(105%);
        opacity: 1;
    }

    .monitoring-slide-x-leave-active,
    .monitoring-slide-x-enter-active {
        transition: .4s ease-in-out;
    }
    .monitoring-slide-x-enter {
        transform: translateX(0);
        opacity: 0;
    }
    .monitoring-slide-x-leave-to {
        transform: translateX(0);
        opacity: 0;
    }

    /*.monitoring-slide-x-enter-active {*/
    /*    animation: monitoring-slide-left .6s forwards;*/
    /*}*/

    /*.monitoring-slide-x-leave-active {*/
    /*    animation: monitoring-slide-left .6s reverse;*/
    /*}*/

    /*@keyframes monitoring-slide-left {*/
    /*    0% {*/
    /*        transform: translateX(0);*/
    /*        opacity: 0;*/
    /*    }*/
    /*    65% {*/
    /*        transform: translateX(-125px);*/
    /*        opacity: 0.8;*/
    /*    }*/

    /*    100% {*/
    /*        transform: translateX(-120px);*/
    /*        opacity: 1;*/
    /*    }*/
    /*}*/
</style>